import { defineComponent, h } from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';

import FormFieldset from './formFieldset.jsx';

// This component is specifically intended to provide services to the
// TTS Voice Picker and the Locale dropdown (usually basic icon picker)
// in the form of preloaded AllVoices and LocaleData.
export default defineComponent({
    name: 'sform-localesection',
    mixins: [BaseComponent],
    components: {
        FormFieldset
    },
    data: () => ({
        ready: false,
        localeexpn: null,
    }),
    props: {
    },
    created() {
    },
    async mounted() {
        await this.loadAllVoices();
        this.buildVoiceMap();

        if (this.element.ControlData.locale)
            this.localeexpn = utils.compile(this, this.element.ControlData.locale);

        this.loadComplete();
        this.ready = true;
    },
    computed: {
        locale() {
            if (this.localeexpn)
                return utils.evaluate(this.localeexpn, this) || 'en-us';
            else
                return 'en-us';
        },
    },
    methods: {
        async loadAllVoices() {
            if (!utils.global.AllVoices)
                utils.global.AllVoices = await utils.api.get('Apps/Locale/GetAvailableTTSVoices', false, true);

            if (!utils.global.LocaleList)
                this.saveListItems(await utils.api.get('Apps/CMPhoneUtils/GetMappings', false, true));
        },
        buildVoiceMap() {
            if (utils.global.VoiceMap)
                return;

            let map = {};
            let regionMap = {};
            let allVoice = utils.global.AllVoices;

            for (let i = 0; i < allVoice.length; i++) {
                let voice = allVoice[i];
                let region = voice.Region.toLowerCase();
                let locale = voice.Locale.toLowerCase();
                if (!map[region]) {
                    map[region] = [];
                }
                if (!map[locale]) {
                    map[locale] = [];
                }
                if (!regionMap[region]) {
                    regionMap[region] = [];
                }
                map[region].push(voice);
                map[locale].push(voice);
                regionMap[region] = locale;
                regionMap[locale] = locale;
            }
            let allLocales = utils.global.LocaleList;

            for (let j = 0; j < allLocales.length; j++) {
                let loc = allLocales[j];
                if (loc.key.indexOf("-") >= 0) {
                    if (!map[loc.key]) {
                        let locPieces = loc.key.split("-");
                        let missingRegion = locPieces[0];
                        map[loc.key] = map[missingRegion]
                        regionMap[loc.key] = missingRegion;
                    }
                }
            }

            utils.global.VoiceMap = map;
            utils.global.RegionMap = regionMap;
        },
        saveListItems(countryInfoMappings) {
            let mappingsDict = {};
            countryInfoMappings.forEach(el => {
                if (el.countrycode) {
                    let key = el.countrycode.toLowerCase();
                    mappingsDict[key] = el;
                }
            })

            let availLangs = this.getAvailableLanguages();
            let listItems = [];


            availLangs.forEach(availLang => {
                // Put the language in the list 
                let langDisplay = '';

                if (availLang.native) {
                    langDisplay = availLang.native; // + ' (' + availLang.name + ')';
                }
                else {
                    langDisplay = availLang.name;
                }

                let langObj = {
                    "key": availLang.key,
                    "display": langDisplay,
                    "flagpath": null
                };

                listItems.push(langObj);

                availLang.locales.forEach(availLocale => {
                    let flagpath = null;

                    let parts = availLocale.key.split('-');
                    let lang = '';
                    let locale = '';

                    if (parts.length === 0) {
                        return; // Same as continue in typical for-loop
                    }
                    else if (parts.length === 1) {
                        lang = parts[0];
                        locale = parts[0];
                    }
                    else {
                        lang = parts[0];
                        locale = parts.splice(1).join("-");
                    }

                    if (locale in mappingsDict) {
                        flagpath = mappingsDict[locale].flagpath;
                    }

                    let localeObj = {
                        "key": availLocale.key,
                        "display": langDisplay + ' - ' + availLocale.name,
                        "flagpath": flagpath
                    };

                    listItems.push(localeObj);
                })
            });

            utils.global.LocaleList = listItems;

            return true;
        },
        getAvailableLanguages() {
            // debugger;
            var generalList = this.System.AvailableLanguages;
            if (this.System.WhiteLabel.LimitLanguages && JSON.parse(this.System.WhiteLabel.LimitLanguages)) {
                var whiteLabelList = JSON.parse(this.System.WhiteLabel.Languages);
                generalList = generalList.filter(l => whiteLabelList.includes(l.key));
            }

            generalList.forEach(el => {
                if (el.hasOwnProperty('native')) {
                    el.display = el.native + " (" + el.name + ")";
                }
                else {
                    el.display = el.name;
                }
            });

            return generalList;
        },
    },
    render() {
        if (!this.ready || !this.schema || !this.form)
            return null;

        return (
            <FormFieldset
                layouttype={this.layouttype}
                root={this.root}
                form={this.form}
                cmodel={this.cmodel}
                modelkey={this.modelkey}
                element={this.element}
                appearance={this.appearance}
                noinput={this.noinput}
                schema={this.schema}
                scopeitems={this.scopeitems}
                controlscope={this.controlscope}
                depth={this.depth}
                nopadding={true}
                isArrayItem={this.isArrayItem}
                nestedInTitledFieldset={this.nestedInTitledFieldset}
                columns={this.element?.ControlData?.columns}>
            </FormFieldset>
        );
    }
});
